import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { UserService } from 'core/user.service';
import { Application } from 'api/models';
import { AppAccess, AppAccessKey } from './app-access.types';
import { AppAccessDialogComponent } from './app-access-dialog.component';

@Component({
  selector: 'qas-header',
  templateUrl: './header.component.html',
  styleUrls: [ './header.component.scss' ]
})
export class HeaderComponent {
  // ref for enum inside class: https://stackoverflow.com/questions/29844959/enum-inside-class-typescript-definition-file/47600870
  static readonly AppAccess = AppAccess;
  readonly AppAccess = HeaderComponent.AppAccess;

  readonly appDescriptions = {
    manager: 'qTest Manager: Agile Test Management',
    sessions: 'qTest Explorer: Exploratory and Session Based Testing Tool',
    insights: 'qTest Insights: Actionable, Real-time Test Metrics',
    pulse: 'qTest Pulse: Powering Agile and DevOps Workflows',
    parameters: 'qTest Parameters: Test Data Management',
    launch: 'qTest Launch: Centralized Test Automation',
    analytics: 'Analytics: Enterprise Custom Reporting for the Tricentis Platform',
    testproject: 'TestProject: Easy Test Automation for All'
  };

  readonly appMessages: AppAccessKey<string> = {
    NO_LICENSE: 'Contact us today to see the benefits of these additional products.',
    NOT_CONFIGURED: 'Please contact our customer support to gain access',
    NO_PERMISSION: 'Please ask your site administrator for access',
    ACCESSIBLE: '' // customized element
  };

  constructor(public userService: UserService, private router: Router, public dialog: MatDialog) {
  }

  logout() {
    this.userService.logout();
    this.router.navigate(['']);
  }

  checkAccess(app: Application): AppAccess {
    if (!app.hasLicense) {
      return AppAccess.NO_LICENSE;
    }
    if (!app.url) {
      return AppAccess.NOT_CONFIGURED;
    }
    if (!app.hasPermission) {
      return AppAccess.NO_PERMISSION;
    }
    return AppAccess.ACCESSIBLE;
  }

  greyOut(access: AppAccess): boolean {
    return access === AppAccess.NO_LICENSE || access === AppAccess.NOT_CONFIGURED;
  }

  openApp(app: Application) {
    let message: string | null = null;

    message = this.appMessages[this.checkAccess(app)];

    if (message) {
      this.dialog.open(AppAccessDialogComponent, {
        width: '450px',
        data: { message, access: this.checkAccess(app) }
      });
    } else {
      window.open(app.url, '_blank');
    }
  }

  checkIfThereIsNoLicensedApp(apps: Application[]) {
    for (const app of apps) {
      if (this.checkAccess(app) === AppAccess.NO_LICENSE) {
        return true;
      }
    }
    return false;
  }
}
